import {AbstractControl, FormGroup, ValidatorFn} from '@angular/forms';

export function TimeValidation(): ValidatorFn {
  return (control: AbstractControl) => {

  var time_exp = new RegExp('^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$');

  if (time_exp.test(control.value))
  {
      return null;
  }
  else
  {
    return {'time' : true };
  }
  }
};





